module.exports = __webpack_public_path__ + "static/img/06_echo.452db76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moments/06_echo.png
// module id = xND4
// module chunks = 1